import React from 'react';

const RefWrapper: React.FC<any> = React.forwardRef(({ children }, ref) => {
    return <div ref={ref as React.RefObject<HTMLDivElement>}>{children}</div>;
});

export default RefWrapper;
